import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-white/5 bg-ink-2" data-id="element-15" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" data-id="element-16" data-mp="autgn7qh51wi">
        <h2 className="text-center font-display text-2xl font-black text-white sm:text-4xl" data-id="element-17" data-mp="ftegv75q7lky">
          🎁 5 Strategic Bonuses — Always Included
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-18" data-mp="1wrir121epdg">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-gold/25 bg-ink p-6" data-id="element-19" data-mp="5tw172wumlyp" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-20" data-mp="1r8te8c1ukfgl">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-xs font-bold text-gold" data-id="element-21" data-mp="3id54555371a9">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-22" data-mp="3dd9055we39up" /> Bonus {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-23" data-mp="3r5ykz706m8q8">
                  <span className="text-white/40 line-through" data-id="element-24" data-mp="3n4wlcp2crunq">{b.price}</span>{' '}
                  <span className="text-gold-soft" data-id="element-25" data-mp="2zfaldze5pbeo">FREE</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-26" data-mp="2uh0rrt82yiv6">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-27" data-mp="2uiu15ga2vh6v">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-gold/40 bg-gold/10 p-6 text-center" data-id="element-28" data-mp="33gw80cght422">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-29" data-mp="npi287y9foqj">
            💰 Total bonus value: <span className="text-white/50 line-through" data-id="element-30" data-mp="ir6rlv055a79">$45</span>{' '}
            <span className="text-[15px] text-gold" data-id="element-31" data-mp="itavwe1ycb82">TODAY FREE WITH THE ACADEMIC EDGE</span>
          </p>
        </div>
      </div>
    </section>;
}